<template>
  <v-app dark>     
    <v-content class="blue darken-4">                
      <v-container fluid fill-height>          
        <v-layout column justify-center align-center>

            <v-spacer></v-spacer>

            <v-flex row xs12 sm8 md4>

              <div class="mb-5">
                <v-alert :value="error" outline color="white" icon="warning">
                  <div v-if="error === 'The email address is badly formatted.'">
                    {{ $t('message.the_email_address_is_badly_formatted') }}
                  </div>
                  <div v-else-if="error === 'Password should be at least 6 characters'">
                    {{ $t('message.password_must_be_at_least_6_characters') }}
                  </div>                                   
                  <div v-else>
                    {{ error }}
                  </div>
                </v-alert>
              </div>
              <form @submit.prevent="onSignup">
                <div class="mb-4">
                  <h2 class="display-2">{{ $t('message.inobram_plataform') }}</h2>
                </div>              

                <v-text-field                    
                    name="name"
                    :label="nameLabel"
                    id="name"
                    type="text"
                    v-model="name"
                    required>
                </v-text-field>
                <v-text-field                    
                    name="email"
                    label="Email"
                    id="email"
                    type="text"
                    v-model="email"
                    required>
                </v-text-field>
                <v-text-field
                    name="password"
                    :label="passwordLabel"
                    id="password"
                    type="password"
                    v-model="password"
                    :rules="[passwordLength]"
                    required>
                </v-text-field>
                <v-text-field
                    name="confirmPassword"
                    :label="confirmPasswordLabel"
                    id="confirmPassword"
                    type="password"
                    v-model="confirmPassword"
                    :rules="[comparePasswords]"
                    required>
                </v-text-field>

                <v-btn                  
                  color="info"
                  type="submit"
                  class="margin-zero"
                  :loading="$store.getters.loading && !error"
                >
                  {{ $t('message.create') }}
                </v-btn>

              </form>

            </v-flex>

            <v-spacer></v-spacer>

            <v-footer class="blue darken-4">
                  <div class="some-margin use-hand-cursor">
                    <v-tooltip top>
                      <img src="/static/img/flag-of-Brazil1.png"
                        alt="Brazil flag" width="26" height="18"
                        slot="activator"
                        @click="changeLanguage('pt_BR')"
                      >
                      <span>Português</span>
                    </v-tooltip>
                  </div>

                  <div class="some-margin use-hand-cursor">
                    <v-tooltip top>
                      <img src="/static/img/flag-of-United-States-of-America1.png"
                        alt="United States of America flag" width="26" height="18"
                        slot="activator"
                        @click="changeLanguage('en_US')"
                      >
                      <span>English</span>
                    </v-tooltip>
                  </div>
                  
                  <div class="some-margin use-hand-cursor">
                    <v-tooltip top>
                      <img 
                        src="/static/img/flag-of-Spain1.png"
                        alt="Spain flag" width="26" height="18"
                        slot="activator"
                        @click="changeLanguage('es_ES')"
                      >
                      <span>Español</span>
                    </v-tooltip>
                  </div>
            </v-footer>

        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      nameLabel: this.$t('message.name'),
      passwordLabel: this.$t('message.password'),
      confirmPasswordLabel: this.$t('message.confirm_the_password'),
      passwordMustBeAtLeast6Characters: this.$t('message.password_must_be_at_least_6_characters'),
      name: '',
      email: '',
      password: '',
      confirmPassword: ''
    }
  },
  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'As senhas devem ser iguais' : ''
    },
    passwordLength () {
      if (this.password !== null && this.password.length < 6) {
        return this.passwordMustBeAtLeast6Characters
      }
      return ''
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    locale: function () {
      return this.$store.getters.language
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/signin')
      }
    },
    locale: function (value) {
      this.nameLabel = this.$t('message.name')
      this.passwordLabel = this.$t('message.password')
      this.confirmPasswordLabel = this.$t('message.confirm_the_password')
      this.passwordMustBeAtLeast6Characters = this.$t('message.password_must_be_at_least_6_characters')
    }
  },
  methods: {
    onSignup () {
      // Take a look it
      // if (this.passwordLength !== '' & this.comparePasswords !== '') {
      this.$store.dispatch('signUserUp', {
        name: this.name,
        email: this.email,
        password: this.password
      })
      // }
    },
    changeLanguage (language) {
      this.$i18n.locale = language
      this.$store.dispatch('setLanguage', language)
    }
  }
}
</script>

<style scoped>

  .margin-zero {
    margin-left: 0px !important;
  }

  .some-margin {
    margin-top: 8px;
    margin-right: 5px;
  }  

  .use-hand-cursor {
    cursor: pointer;
  }  

</style>


// WEBPACK FOOTER //
// src/components/Auth/Signup.vue